import VcsDetailsPage from "../../shared/VcsShared/components/VcsDetailsPage";

const BlobStorageDetailsPage = VcsDetailsPage;

export default BlobStorageDetailsPage;
